// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__gfydg","modal__title":"styles_modal__title__5pzm0","modal__footer":"styles_modal__footer__TSo8R"};